export const separateRoles = (investigators) => {
  let ips = investigators
    .filter(({ coreFacilityRole }) => coreFacilityRole === "ip")
    .map(({ staff }) => staff);
  let participants = investigators
    .filter(({ coreFacilityRole }) => coreFacilityRole === "participant")
    .map(({ staff }) => staff);
  return { ips: cleanUsers(ips), participants: cleanUsers(participants) };
};

export const cleanUsers = (users) => {
  let cleanedUsers = [];
  users.map(({ id, nombre, apellidos }) =>
    cleanedUsers.push({ id, nombre, apellidos })
  );
  return cleanedUsers;
};

export const uniqueUsers = (set1, set2) =>
  [].concat(
    set1?.filter((set) => set2.every(({ id }) => set.id !== id)),
    set2.filter((set) => set1?.every(({ id }) => set.id !== id))
  );

export const buildInvestigatorCoreFacility = (participants, ips, coreFacilityId) => {
  participants = participants.map(({ id }) => ({
    coreFacilityRole: "PARTICIPANT",
    staffId: id,
    coreFacilityId,
  }));
  ips = ips.map(({ id }) => ({
    coreFacilityRole: "ip",
    staffId: id,
    coreFacilityId,
  }));
  return participants.concat(ips);
};
